// import React, {Component} from 'react';
// import {
//     Table,
//     TableBody,
//     TableHeader,
//     TableHeaderColumn,
//     TableRow,
//     TableRowColumn,
// } from 'material-ui/Table';
//
// export default class YosanSummaryCsvTable extends Component {
//
//     render() {
//         const {
//             summaryCsv
//         } = this.props
//
//         let header = [];
//         let records = [];
//         if (summaryCsv && summaryCsv != '') {
//             const tmpData = summaryCsv.split("\n")
//             console.log('tmpData', tmpData)
//             header = tmpData[0].split(",")
//             const tmpRecords = tmpData.slice(1, tmpData.length);
//             tmpRecords.forEach(x => {
//                 records.push(x.split(","))
//             })
//             console.log('header', header)
//             console.log('records', records)
//         }
//
//         return (
//             <Table style={{width: '100%'}}
//                    fixedHeader={true}
//             >
//                 <TableHeader
//                     displaySelectAll={false}
//                     adjustForCheckbox={false}
//                 >
//                     <TableRow>
//                         {header && header.map((x, index) => {
//                             return (<TableHeaderColumn style={{width: 100}} key={index}>{x}</TableHeaderColumn>)
//                         })}
//                     </TableRow>
//                 </TableHeader>
//                 <TableBody
//                     displayRowCheckbox={false}
//                     style={{width: '800px'}}
//                 >
//                     {
//                         records && records.map((record, parentIndex) => {
//                             return (
//                                 <TableRow key={parentIndex} style={{width: '800px'}}>
//                                     <TableRowColumn>{record[0]}</TableRowColumn>
//                                     <TableRowColumn>{record[1]}</TableRowColumn>
//                                     <TableRowColumn>{record[2]}</TableRowColumn>
//                                 </TableRow>
//                             )
//                         })
//                     }
//                 </TableBody>
//             </Table>
//         );
//     }
// }


import React, {Component} from 'react';
import {
    Table,
    TableBody,
    TableFooter,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import Toggle from 'material-ui/Toggle';
import * as commons from '../../commons'

const styles = {
    propContainer: {
        width: 200,
        overflow: 'hidden',
        margin: '20px auto 0',
    },
    propToggleHeader: {
        margin: '20px auto 10px',
    },
};

const tableData = [
    {
        name: 'John Smith',
        status: 'Employed',
    },
    {
        name: 'Randal White',
        status: 'Unemployed',
    },
    {
        name: 'Stephanie Sanders',
        status: 'Employed',
    },
    {
        name: 'Steve Brown',
        status: 'Employed',
    },
    {
        name: 'Joyce Whitten',
        status: 'Employed',
    },
    {
        name: 'Samuel Roberts',
        status: 'Employed',
    },
    {
        name: 'Adam Moore',
        status: 'Employed',
    },
];

/**
 * A more complex example, allowing the table height to be set, and key boolean properties to be toggled.
 */
export default class TableExampleComplex extends Component {
    state = {
        fixedHeader: true,
        fixedFooter: true,
        stripedRows: false,
        showRowHover: false,
        selectable: true,
        multiSelectable: false,
        enableSelectAll: false,
        deselectOnClickaway: true,
        showCheckboxes: true,
        height: '300px',
    };

    render() {

        const {
            summaryCsv
        } = this.props

        let header = [];
        let records = [];
        if (summaryCsv && summaryCsv != '') {
            const tmpData = summaryCsv.split("\n")
            header = tmpData[0].split(",")
            const tmpRecords = tmpData.slice(1, tmpData.length);
            tmpRecords.filter(x => x).forEach(x => {
                records.push(x.split(","))
            })
        }

        return (
            <div>
                <Table
                    height={this.state.height}
                    fixedHeader={true}
                    selectable={this.state.selectable}
                    multiSelectable={this.state.multiSelectable}
                    bodyStyle={{width: 2300}}
                >
                    <TableHeader
                        displaySelectAll={false}
                        adjustForCheckbox={false}
                        enableSelectAll={false}
                    >
                        <TableRow>
                            <TableHeaderColumn style={{width:100}}>{header[0]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:100}}>{header[1]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:100}}>{header[2]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[3]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[4]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[5]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[6]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[7]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[8]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[9]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[10]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[11]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[12]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[13]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[14]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[15]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[16]}</TableHeaderColumn>
                            <TableHeaderColumn style={{width:135}}>{header[17]}</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody
                        displayRowCheckbox={false}
                        deselectOnClickaway={this.state.deselectOnClickaway}
                        showRowHover={this.state.showRowHover}
                        stripedRows={this.state.stripedRows}
                    >
                        {records.map( (row, index) => (
                            <TableRow key={index}>
                                <TableRowColumn style={{width:100}}>{row[0]}</TableRowColumn>
                                <TableRowColumn style={{width:100}}>{row[1]}</TableRowColumn>
                                <TableRowColumn style={{width:100}}>{row[2]}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispMoney(row[3])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispMoney(row[4])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispMoney(row[5])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispMoney(row[6])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispMoney(row[7])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispAvg(row[8])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispMoney(row[9])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispMoney(row[10])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispMoney(row[11])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispMoney(row[12])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispMoney(row[13])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispMoney(row[14])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispAvg(row[15])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispMoney(row[16])}</TableRowColumn>
                                <TableRowColumn style={{width:135}}>{commons.dispAvg(row[17])}</TableRowColumn>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/yosan/YosanSummaryCsvTable.js